module.exports = "textarea.ng-invalid.ng-touched, textarea:focus.ng-invalid {\n  border: red 4px solid;\n}\n\ntextarea:focus.ng-valid {\n  border: green 4px solid;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/remittance-entry/remittance-summary/remittance-summary.component.css
// module id = ./src/app/components/remittance-entry/remittance-summary/remittance-summary.component.css
// module chunks = main